const bTabs = {
    props: {
        activeTab:{
            type: String,
            default: ''
        },
        tabs: {
            type: Array,
            default(){
                return []
            }
        }
    },
    data(){
        return {
            tab: null,
        }
    },
    template:
    `<div class="b-tabs">
        <ul class="b-tabs__nav">
            <li v-for="tab in tabs" :class="activeClass(tab.type)">
                <button type="button" class="b-tabs__lnk ui-tabs-anchor" @click="changeTab(tab.type)">                   
                    <span class="b-tabs__lnk__txt">{{tab.label}} <i class="b-tabs__lnk__count" v-if="tab.count">({{tab.count}})</i></span>
                </button>
            </li>
        </ul>
    </div>`,
    mounted(){
        this.iniTabs();
        
    },
    methods:{
        iniTabs(){
            if(this.activeTab!==''){
                this.tab = this.activeTab            
            } else {
                if(this.tabs.length && this.tabs[0].type)
                    this.tab = this.tabs[0].type
            }
            this.$emit("onTabInit", this.tab)
        },
        
        changeTab(newTab){
            this.tab = newTab
            this.$emit("onTabChanged", this.tab)
        },

        activeClass(tab){
            if(this.tab === tab){
                return 'ui-tabs-active'
            }
            return ''
        }
    }
}